const STORAGE_KEY = 'artisan-scrolls-cookie-consent';
const SHOW_DELAY_MS = 1500;
const DISMISS_TRANSITION_MS = 400;

function initCookieConsent() {
  const banner = document.getElementById('CookieConsent');
  if (!banner) return;

  // Already decided on a previous visit — never show again.
  if (window.localStorage.getItem(STORAGE_KEY)) return;

  const acceptButton = banner.querySelector('[data-cookie-consent-accept]');
  const declineButton = banner.querySelector('[data-cookie-consent-decline]');

  function dismiss(decision) {
    window.localStorage.setItem(STORAGE_KEY, decision);
    banner.removeAttribute('data-visible');
    banner.setAttribute('data-dismissing', '');

    window.setTimeout(() => {
      banner.hidden = true;
    }, DISMISS_TRANSITION_MS);
  }

  acceptButton?.addEventListener('click', () => dismiss('accepted'));
  declineButton?.addEventListener('click', () => dismiss('declined'));

  window.setTimeout(() => {
    banner.hidden = false;
    // Force a reflow so the entrance transition actually plays instead of the
    // hidden -> visible state jumping straight to its end value.
    void banner.offsetHeight;
    banner.setAttribute('data-visible', '');
  }, SHOW_DELAY_MS);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookieConsent);
} else {
  initCookieConsent();
}
